import { render, staticRenderFns } from "./UnitMalhaRoutes.vue?vue&type=template&id=792fb7d2&scoped=true"
import script from "./UnitMalhaRoutes.vue?vue&type=script&lang=js"
export * from "./UnitMalhaRoutes.vue?vue&type=script&lang=js"
import style0 from "./UnitMalhaRoutes.vue?vue&type=style&index=0&id=792fb7d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792fb7d2",
  null
  
)

export default component.exports